import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=bc54bbda"
import script from "./tagInput.vue?vue&type=script&lang=js"
export * from "./tagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports